import React, { createRef } from "react";
import styled, { css } from "styled-components";

import MaterialButton from "@material-ui/core/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Row, Box } from "./box";

const Wrapper = styled(Row)`
  width: 100%;
  height: 100%;
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.6);
  border-radius: 5px;
  overflow: hidden;
  background: ${({ background }) => background};
`;

const Input = styled.input`
  width: ${({ width }) => width};
  flex-grow: 0;
  flex-shrink: 0;
  text-align: center;
  font-size: ${({ fontSize }) => fontSize || "12px"};
  background: transparent;
  padding-left: 10px;
  padding-right: 10px;
  color: ${({ textColor }) => textColor || "#fff"};
  text-align: ${({ textAlign }) => textAlign || "center"};
  ${({ textAlign }) =>
    textAlign === "left" &&
    css`
      padding-left: 10px;
    `}
  border: 0px;
  outline: none;
  &:focus::placeholder {
    color: transparent;
  }
  &::placeholder {
    color: ${({ textColor }) => textColor || "#fff"};
    opacity: 0.6;
  }
  &:-ms-input-placeholder {
    color: ${({ textColor }) => textColor || "#fff"};
  }
  &::-ms-input-placeholder {
    color: ${({ textColor }) => textColor || "#fff"};
  }
`;
const ButtonWrapper = styled(Box)`
  width: ${({ width }) => width};
  height: 100%;
`;

export default ({
  placeholder,
  textColor,
  background,
  textAlign,
  fontSize,
  buttonTextColor,
  buttonBackground,
  buttonName,
  buttonIcon,
  buttonRatio,
  buttonFontSize,
  onClick,
  inputId,
}) => {
  const refInput = createRef();
  const inputWidth = 100 - buttonRatio;

  return (
    <Wrapper background={background}>
      <Input
        ref={refInput}
        id={inputId}
        type="text"
        placeholder={placeholder}
        textColor={textColor}
        textAlign={textAlign}
        fontSize={fontSize}
        width={(inputWidth && inputWidth + "%") || "80%"}
      />
      <ButtonWrapper width={(buttonRatio && buttonRatio + "%") || "20%"}>
        <MaterialButton
          style={{
            width: `100%`,
            height: `100%`,
            fontSize: buttonFontSize || "16px",
            color: buttonTextColor || "#fff",
            borderRadius: 0,
            backgroundColor: buttonBackground || `#59B0F6`,
          }}
          variant="contained"
          color="secondary"
          startIcon={buttonIcon && <FontAwesomeIcon icon={buttonIcon} />}
          onClick={() => {
            onClick(refInput.current.value);
          }}
        >
          {buttonName}
        </MaterialButton>
      </ButtonWrapper>
    </Wrapper>
  );
};
